(function () {
  'use strict';

  function initGallery(root) {
    if (!root || root.dataset.mpGalleryInitialized === 'true') {
      return;
    }

    root.dataset.mpGalleryInitialized = 'true';

    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-mp-gallery-tab]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-mp-gallery-panel]'));

    var lightbox = root.querySelector('[data-mp-gallery-lightbox]');
    var lightboxImage = root.querySelector('[data-mp-gallery-lightbox-image]');
    var lightboxPrev = root.querySelector('[data-mp-gallery-lightbox-prev]');
    var lightboxNext = root.querySelector('[data-mp-gallery-lightbox-next]');
    var triggers = Array.prototype.slice.call(root.querySelectorAll('[data-mp-gallery-lightbox-trigger]'));
    var beforeToggles = Array.prototype.slice.call(root.querySelectorAll('[data-mp-gallery-before-toggle]'));
    var closeButtons = Array.prototype.slice.call(root.querySelectorAll('[data-mp-gallery-lightbox-close]'));

    var activeLightboxItems = [];
    var activeLightboxIndex = 0;
    var touchStartX = 0;
    var touchStartY = 0;
    var preloadedImages = {};

    function updatePanelOverflow(panel) {
      var track = panel.querySelector('[data-mp-gallery-track]');

      if (!track) {
        return;
      }

      var hasOverflow = track.scrollWidth > track.clientWidth + 2;

      panel.classList.toggle('has-overflow', hasOverflow);
    }

    function updateAllPanelOverflow() {
      panels.forEach(function (panel) {
        updatePanelOverflow(panel);
      });
    }

    function preloadImage(src) {
      if (!src || preloadedImages[src]) {
        return;
      }

      preloadedImages[src] = true;

      var image = new Image();
      image.decoding = 'async';
      image.src = src;
    }

    function getCurrentZoomData(trigger) {
      var item = trigger.closest('.mp-gallery-tabs__item');

      if (!item) {
        return {
          src: trigger.getAttribute('data-mp-gallery-image'),
          alt: trigger.getAttribute('data-mp-gallery-alt') || ''
        };
      }

      if (trigger.hasAttribute('data-mp-gallery-current-zoom')) {
        var state = item.getAttribute('data-mp-gallery-state') || 'after';
        var src = state === 'before'
          ? item.getAttribute('data-mp-gallery-before-image')
          : item.getAttribute('data-mp-gallery-after-image');
        var alt = state === 'before'
          ? item.getAttribute('data-mp-gallery-before-alt')
          : item.getAttribute('data-mp-gallery-after-alt');

        return {
          src: src,
          alt: alt || ''
        };
      }

      return {
        src: trigger.getAttribute('data-mp-gallery-image'),
        alt: trigger.getAttribute('data-mp-gallery-alt') || ''
      };
    }

    function preloadAllLightboxImages() {
      triggers.forEach(function (trigger) {
        var data = getCurrentZoomData(trigger);

        preloadImage(data.src);
      });

      Array.prototype.slice.call(root.querySelectorAll('[data-mp-gallery-after-image]')).forEach(function (item) {
        preloadImage(item.getAttribute('data-mp-gallery-after-image'));
        preloadImage(item.getAttribute('data-mp-gallery-before-image'));
      });
    }

    function preloadNearbyImages() {
      if (!activeLightboxItems.length) {
        return;
      }

      var previousIndex = activeLightboxIndex - 1;
      var nextIndex = activeLightboxIndex + 1;

      if (previousIndex < 0) {
        previousIndex = activeLightboxItems.length - 1;
      }

      if (nextIndex >= activeLightboxItems.length) {
        nextIndex = 0;
      }

      preloadImage(getCurrentZoomData(activeLightboxItems[previousIndex]).src);
      preloadImage(getCurrentZoomData(activeLightboxItems[nextIndex]).src);
    }

    function activateTab(tabKey) {
      tabs.forEach(function (tab) {
        var isActive = tab.getAttribute('data-tab-key') === tabKey;

        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        var isActive = panel.getAttribute('data-tab-key') === tabKey;
        var track = panel.querySelector('[data-mp-gallery-track]');

        panel.classList.toggle('is-active', isActive);
        panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');

        if (isActive && track) {
          track.scrollLeft = 0;
        }

        window.requestAnimationFrame(function () {
          updatePanelOverflow(panel);
        });
      });
    }

    function toggleBeforeAfter(control) {
      var item = control.closest('.mp-gallery-tabs__item');

      if (!item) {
        return;
      }

      var isBefore = item.getAttribute('data-mp-gallery-state') === 'before';
      var nextState = isBefore ? 'after' : 'before';

      item.setAttribute('data-mp-gallery-state', nextState);
      control.setAttribute('aria-label', nextState === 'before' ? 'See after image' : 'See before image');
    }

    function getActivePanelItems(trigger) {
      var panel = trigger.closest('[data-mp-gallery-panel]');

      if (!panel) {
        return triggers;
      }

      return Array.prototype.slice.call(panel.querySelectorAll('[data-mp-gallery-lightbox-trigger]'));
    }

    function setLightboxImage(index) {
      if (!lightbox || !lightboxImage || !activeLightboxItems.length) {
        return;
      }

      if (index < 0) {
        index = activeLightboxItems.length - 1;
      }

      if (index >= activeLightboxItems.length) {
        index = 0;
      }

      activeLightboxIndex = index;

      var activeItem = activeLightboxItems[activeLightboxIndex];
      var data = getCurrentZoomData(activeItem);

      if (!data.src) {
        return;
      }

      lightboxImage.src = data.src;
      lightboxImage.alt = data.alt || '';

      preloadNearbyImages();
    }

    function openLightbox(trigger) {
      if (!lightbox || !lightboxImage || !trigger) {
        return;
      }

      activeLightboxItems = getActivePanelItems(trigger);
      activeLightboxIndex = activeLightboxItems.indexOf(trigger);

      if (activeLightboxIndex < 0) {
        activeLightboxIndex = 0;
      }

      setLightboxImage(activeLightboxIndex);

      lightbox.classList.add('is-active');
      lightbox.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeLightbox() {
      if (!lightbox) {
        return;
      }

      lightbox.classList.remove('is-active');
      lightbox.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    function showPreviousLightboxImage() {
      setLightboxImage(activeLightboxIndex - 1);
    }

    function showNextLightboxImage() {
      setLightboxImage(activeLightboxIndex + 1);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var tabKey = tab.getAttribute('data-tab-key');

        if (!tabKey) {
          return;
        }

        activateTab(tabKey);
      });
    });

    panels.forEach(function (panel) {
      var track = panel.querySelector('[data-mp-gallery-track]');
      var prev = panel.querySelector('[data-mp-gallery-prev]');
      var next = panel.querySelector('[data-mp-gallery-next]');

      if (!track) {
        return;
      }

      Array.prototype.slice.call(track.querySelectorAll('img')).forEach(function (image) {
        if (image.complete) {
          updatePanelOverflow(panel);
          return;
        }

        image.addEventListener('load', function () {
          updatePanelOverflow(panel);
        });
      });

      function getScrollAmount() {
        return Math.max(track.clientWidth * 0.85, 280);
      }

      if (prev) {
        prev.addEventListener('click', function () {
          track.scrollBy({
            left: -getScrollAmount(),
            behavior: 'smooth'
          });
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          track.scrollBy({
            left: getScrollAmount(),
            behavior: 'smooth'
          });
        });
      }
    });

    beforeToggles.forEach(function (button) {
      button.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        toggleBeforeAfter(button);
      });

      button.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') {
          return;
        }

        event.preventDefault();
        toggleBeforeAfter(button);
      });
    });

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        openLightbox(trigger);
      });

      trigger.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') {
          return;
        }

        event.preventDefault();
        openLightbox(trigger);
      });
    });

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeLightbox);
    });

    if (lightboxPrev) {
      lightboxPrev.addEventListener('click', showPreviousLightboxImage);
    }

    if (lightboxNext) {
      lightboxNext.addEventListener('click', showNextLightboxImage);
    }

    if (lightbox) {
      lightbox.addEventListener('touchstart', function (event) {
        if (!event.touches || !event.touches.length) {
          return;
        }

        touchStartX = event.touches[0].clientX;
        touchStartY = event.touches[0].clientY;
      }, { passive: true });

      lightbox.addEventListener('touchend', function (event) {
        if (!event.changedTouches || !event.changedTouches.length) {
          return;
        }

        var touchEndX = event.changedTouches[0].clientX;
        var touchEndY = event.changedTouches[0].clientY;
        var diffX = touchEndX - touchStartX;
        var diffY = touchEndY - touchStartY;

        if (Math.abs(diffX) < 45 || Math.abs(diffX) < Math.abs(diffY)) {
          return;
        }

        if (diffX > 0) {
          showPreviousLightboxImage();
        } else {
          showNextLightboxImage();
        }
      }, { passive: true });
    }

    document.addEventListener('keydown', function (event) {
      if (!lightbox || !lightbox.classList.contains('is-active')) {
        return;
      }

      if (event.key === 'Escape') {
        closeLightbox();
      }

      if (event.key === 'ArrowLeft') {
        showPreviousLightboxImage();
      }

      if (event.key === 'ArrowRight') {
        showNextLightboxImage();
      }
    });

    window.addEventListener('resize', updateAllPanelOverflow);

    if (tabs.length > 0) {
      activateTab(tabs[0].getAttribute('data-tab-key'));
    }

    updateAllPanelOverflow();
    window.setTimeout(updateAllPanelOverflow, 300);
    window.setTimeout(updateAllPanelOverflow, 1000);
    window.setTimeout(preloadAllLightboxImages, 800);
  }

  function initAllGalleries(container) {
    var scope = container || document;
    var galleries = scope.querySelectorAll('[data-mp-gallery-tabs]');

    galleries.forEach(function (gallery) {
      initGallery(gallery);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAllGalleries(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAllGalleries(event.target);
  });
})();